const hashtagRegex = require('hashtag-regex');
const HASHTAG_LIMIT = 30;

const countHashtagsInText = text => {
  let counter = 0;

  const regex = hashtagRegex();

  while (regex.exec(text)) {
    counter += 1;
  }
  return HASHTAG_LIMIT - counter;
};

export default countHashtagsInText;
